import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeadzone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M38.849 9.151 24 3 9.151 9.151 3 24l6.151 14.85L24 45l14.849-6.15L45 24zm-14.85 12.414 9.61-5.547v15.964l-9.61-5.547-9.608 5.547V16.018z" })
});
export default SvgDeadzone;
